<template>
  <div class="edrea_tm_section" id="home">
    <div class="section_inner">
      <!-- Ilustraciones de fondo: se funden entre sí, sincronizadas con el texto -->
      <div class="hero_bg_layer">
        <div
          v-for="(slide, i) in slides"
          :key="i"
          class="hero_bg"
          :class="{ active: i === current }"
          :style="{ backgroundImage: `url(${slide.img})` }"
        ></div>
      </div>

      <div class="edrea_tm_home">
        <div class="home_content">
          <!-- El servicio es el titular del hero: rota con la ilustración -->
          <div class="hero_service">
            <transition name="svc" mode="out-in">
              <div :key="current" class="svc_text">
                <span class="svc_tag">{{ slides[current].tag }}</span>
                <h3 class="svc_title">{{ slides[current].title }}</h3>
                <p class="svc_des">{{ slides[current].des }}</p>
              </div>
            </transition>
          </div>

          <div class="home_buttons">
            <div class="edrea_tm_button">
              <a
                href="#services"
                @click.prevent="navFuntions.activeSection('services')"
                >{{ t.home.btnServices }}</a
              >
            </div>
            <div class="edrea_tm_button transparent">
              <a
                href="#contact"
                @click.prevent="navFuntions.activeSection('contact')"
                >{{ t.home.btnContact }}</a
              >
            </div>
          </div>

          <div class="hero_dots">
            <button
              v-for="(slide, i) in slides"
              :key="i"
              type="button"
              :class="{ active: i === current }"
              :aria-label="slide.title"
              @click="go(i)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/i18n";
import { navFuntions } from "@/navFuntions";

const INTERVALO = 6000;

export default {
  name: `HomeComponent`,
  data() {
    return {
      navFuntions,
      current: 0,
      timer: null,
    };
  },
  computed: {
    t() {
      return i18n.m;
    },
    slides() {
      return this.t.slider.items;
    },
  },
  methods: {
    go(i) {
      this.current = i;
      this.start(); // reinicia el ciclo tras un clic manual
    },
    start() {
      this.stop();
      this.timer = setInterval(() => {
        this.current = (this.current + 1) % this.slides.length;
      }, INTERVALO);
    },
    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    },
  },
  mounted() {
    this.start();
  },
  beforeUnmount() {
    this.stop();
  },
};
</script>

<style scoped>
.section_inner {
  position: relative; /* ancla las ilustraciones de fondo */
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding-top: 90px; /* deja libre la franja del header fijo */
  box-sizing: border-box;
}

/* ===== Ilustraciones de fondo ===== */
.hero_bg_layer {
  position: absolute;
  top: calc(-1 * var(--hero-top-offset, 150px));
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: calc(100% + var(--hero-top-offset, 150px));
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.hero_bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center right;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 1.2s ease;
}

.hero_bg.active {
  opacity: 1;
}

/* ===== Contenido: columna izquierda ===== */
.edrea_tm_home {
  position: relative;
  z-index: 2;
  width: 100%;
}

.home_content {
  text-align: left;
  max-width: 560px; /* la ilustración vive a la derecha: no la invadimos */
}

/* ===== Bloque del servicio: es el titular del hero ===== */
.hero_service {
  margin-bottom: 40px;
  /* Altura reservada: evita que los botones salten al cambiar de servicio */
  min-height: 240px;
}

.svc_tag {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--main-color);
  margin-bottom: 14px;
}

.svc_title {
  font-size: 52px;
  line-height: 1.12;
  font-weight: 700;
  color: var(--dm-navy) !important;
  margin-bottom: 18px;
}

.svc_des {
  font-size: 17px;
  line-height: 1.7;
  color: var(--dm-text);
  margin: 0;
  max-width: 480px;
}

/* Transición del texto del servicio */
.svc-enter-active,
.svc-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.svc-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.svc-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ===== Botones ===== */
.home_buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.edrea_tm_button {
  width: auto;
  float: none;
}

.edrea_tm_button.transparent a {
  background-color: transparent;
  border: 1px solid var(--dm-border);
  color: var(--dm-navy) !important;
}

.edrea_tm_button.transparent a:hover {
  background-color: var(--dm-navy);
  border-color: var(--dm-navy);
  color: #fff !important;
}

/* ===== Puntos ===== */
.hero_dots {
  display: flex;
  gap: 8px;
}

.hero_dots button {
  width: 9px;
  height: 9px;
  border: none;
  padding: 0;
  border-radius: 50px;
  background: var(--dm-navy);
  opacity: 0.22;
  cursor: pointer;
  transition: all 0.3s ease;
}

.hero_dots button.active {
  opacity: 1;
  width: 28px;
  background: var(--main-color);
}

@media (max-width: 1040px) {
  .home_content {
    max-width: 480px;
  }
  .svc_title {
    font-size: 40px;
  }
  .hero_service {
    min-height: 220px;
  }
}

@media (max-width: 768px) {
  .section_inner {
    padding-top: 110px;
    padding-bottom: 40px;
  }
  /* En móvil la ilustración no cabe al lado: se pone tenue detrás del texto */
  .hero_bg {
    background-position: center;
    opacity: 0;
  }
  .hero_bg.active {
    opacity: 0.35;
  }
  .home_content {
    max-width: none;
    text-align: center;
  }
  .svc_title {
    font-size: 32px;
  }
  .svc_des {
    font-size: 15px;
    max-width: none;
  }
  .hero_service {
    min-height: 210px;
  }
  .home_buttons,
  .hero_dots {
    justify-content: center;
  }
}
</style>
